import type { RichTextToolbarFragment } from "../client/generated";
import { Editor } from "@tiptap/react";
import { LanguagePicker } from "./LanguagePicker";
import { TextColorPicker } from "./TextColorPicker";
import { FormulaRefPicker } from "./FormulaRefPicker";
import { BoldFormattingToggle } from "./BoldFormattingToggle";
import { ItalicFormattingToggle } from "./ItalicFormattingToggle";
import { StrikeFormattingToggle } from "./StrikeFormattingToggle";
import { UnderlineFormattingToggle } from "./UnderlineFormattingToggle";
import { FootnoteRefPicker } from "./FootnoteRefPicker";

type Props = {
  fragment: RichTextToolbarFragment;
  editor: Editor;
};

export function RichTextToolbar({ fragment, editor }: Props) {
  return (
    <div className="flex justify-center flex-wrap p-1 gap-1">
      <BoldFormattingToggle editor={editor} />
      <ItalicFormattingToggle editor={editor} />
      <StrikeFormattingToggle editor={editor} />
      <UnderlineFormattingToggle editor={editor} />
      <LanguagePicker editor={editor} />
      <TextColorPicker editor={editor} />
      <FormulaRefPicker fragment={fragment} editor={editor} />
      <FootnoteRefPicker fragment={fragment} editor={editor} />
    </div>
  );
}
